import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';

import {ModalConfirmationComponent} from 'shared/modals/modal-confirmation/modal-confirmation.component';
import {Question} from 'shared/models/questions/question';
import {SearchBarComponent} from 'shared/search-bar/search-bar.component';
import {TreeListService} from './services/tree-list.service';

@Component({
  selector: 'tree-list',
  templateUrl: './tree-list.component.html',
  styleUrls: ['./tree-list.component.css'],
})

export class TreeListComponent implements OnInit {
  public rootQuestions: Array<Question> = [];
  public searchTerm: string;
  public currentPage: Event;
  public filteredRootQuestions: Array<Question>;
  public fieldsToSearch: Array<Array<string>> = [];
  @ViewChild('deleteModal') private deleteModal: ModalConfirmationComponent;

  constructor(private treeListService: TreeListService,
              private router: Router) { }

  public ngOnInit(): void {
    this.getRootQuestions();
  }

  public getRootQuestions(): void {
    this.treeListService.getRootQuestions()
      .subscribe((rootQuestions) => {
        this.rootQuestions = rootQuestions;
        this.filteredRootQuestions = rootQuestions;
        this.prepareFieldstoSearch();
      });
  }

  public editTree(treeId: string): void {
    this.router.navigate(['treeview', {treeId: treeId}]);
  }

  public newTree(): void {
    this.router.navigateByUrl('/treeview');
  }

  public deleteTree(id: string): void {
    this.treeListService.deleteTree(id)
      .subscribe((res) => {
        this.getRootQuestions();
      });
  }

  public filterRootQuestions(eventRootQuestions: Array<Question>): void {
    this.filteredRootQuestions = eventRootQuestions;
  }

  private prepareFieldstoSearch(): void {
    this.rootQuestions.forEach((question) => {
          this.fieldsToSearch.push([
            question.title.de.toLowerCase(),
            question._id.toLowerCase(),
          ]);
        });
  }

  private showDeleteModal(questionId: number): void { // tslint:disable-line
    const content: string = `Sind Sie wirklich sicher, dass Sie diesen Fragenbaum löschen möchten?`;

    this.deleteModal.setContent(content)
      .setEventData(questionId)
      .show();
  }

}



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/dynamic-tips/tree-list/tree-list.component.ts